import React from 'react';

import ReactMarkdown from 'react-markdown';

import nonBreakingSpace from '../utils/remarkNonBreakingSpace';

const MarkdownContent = ({ children, className, isInline }) => {
	if (isInline) {
		return (
			<div className={className}>
				<ReactMarkdown
					remarkPlugins={[nonBreakingSpace]}
					disallowedElements={['p']}
					unwrapDisallowed
				>
					{children}
				</ReactMarkdown>
			</div>
		);
	}
	return (
		<div className={className}>
			<ReactMarkdown remarkPlugins={[nonBreakingSpace]}>
				{children}
			</ReactMarkdown>
		</div>
	);
};

export default MarkdownContent;
